<template>
  <div class="main-container">
    <div v-if="showPanel === false" class="search-summary container-fluid">
      <div class="row">
        <div class="col-md-3 border-left search-summary-item">
          <div class="row">
            <div class="origin container col-md-6 border-left">
              <span class="label row">  {{ $t("HomeHeader.Source") }}</span>
              <span class="title row">{{ searchedItems.origin }}</span>
            </div>
            <div class="destination container col-md-6">
              <span class="label row">{{ $t("HomeHeader.Destination") }}</span>
              <span class="title row">{{ searchedItems.destination }}</span>
              <div class="icondirection">
                <i
                  style="font-size: 20px; color: #00c3e1"
                  class="icon-exchange-1"
                ></i>
              </div>
            </div>
          </div>
        </div>

        <div class="departure container col-md-2 border-left search-summary-item">
          <span class="label row">{{ $t("HomeHeader.DepartureDate") }}</span>
          <span class="title row">{{ searchedItems.fromDate }}</span>
        </div>
        <div class="return container col-md-2 border-left search-summary-item">
          <span class="label row">{{ $t("HomeHeader.ReturnDate") }}</span>
          <span class="title row">{{ searchedItems.toDate }}</span>
        </div>
        <div class="pax container col-md-1 border-left search-summary-item">
          <span class="label row">{{ $t("FastTrack.Count") }} {{ $t("HomeHeader.Room") }}</span>
          <span class="title row">{{ searchedItems.roomsCount }}</span>
        </div>
        <div class="pax container col-md-1 search-summary-item">
          <span class="label row">{{ $t("SearchResults.PassengersCount") }}</span>
          <span class="title row">{{ searchedItems.pax }}</span>
        </div>
        <div class="col-md-3 btn-side">
          <a @click="showPanel = !showPanel" class="btn_full_outline btn_change"
            >{{ $t("SearchResults.ChangeSearch") }}</a
          >
        </div>
      </div>
    </div>

    <div v-if="showPanel === false" class="search-summary-mobile container-fluid">
      <div class="row" >
        <div class="col-md-6" style="display: flex;">
          <div  class="border-left-mobile" >
              <div >
                <span class="label">{{ $t("HomeHeader.Source") }}:</span>
                <span class="title-mobile ">{{ searchedItems.origin }}</span>
              </div>
              <div >
                <span class="label ">{{ $t("HomeHeader.Destination") }}:</span>
                <span class="title-mobile ">{{ searchedItems.destination }}</span>
              
              </div>
            </div>
          <div class="border-left-mobile">
            <span class="label ">{{ $t("HomeHeader.DepartureDate") }}</span>
            <span class="title-mobile ">{{ searchedItems.fromDate }}</span>
          </div>
          <div class="border-left-mobile">
            <span class="label ">{{ $t("HomeHeader.ReturnDate") }}</span>
            <span class="title-mobile ">{{ searchedItems.toDate }}</span>
          </div>
          <div class=" border-left-mobile">
            <span class="label ">{{ $t("FastTrack.Count") }} {{ $t("HomeHeader.Room") }}</span>
            <span class="title-mobile ">{{ searchedItems.roomsCount }}</span>
          </div>
          <div class="border-left-mobile">
            <span class="label ">{{ $t("SearchResults.PassengersCount") }}</span>
            <span class="title-mobile ">{{ searchedItems.pax }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <a @click="showPanel = !showPanel" style="width: 100%;margin-top: 12px;" class="btn_full_outline btn_change"
            >{{ $t("SearchResults.ChangeSearch") }}</a
          >
        </div>
      </div>
    </div>
    <transition name="searchbox">
      <div class="searchbox" v-if="showPanel">
        <div class="close-btn">
          <i @click="showPanel = false" class="icon_set_1_icon-77"></i>
        </div>
        <div id="searchForm" class="row">
          <SearchBox :selectedRooms="searchedItems.rooms" />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import SearchBox from "@/components/tour/ChangeSearchForm";
export default {
  name: "ChangeSearch",
  components: { SearchBox },
  props: {
    searchItems: Object,
    showChangeSearch: false,
  },

  data: () => ({
    showPanel: false,
  }),

  computed: {
    searchedItems() {
      return (this.searchItems = this.searchItems);
    },
    isShowChangeSearch(val) {
      return (this.showChangeSearch = this.showChangeSearch);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  margin-top: 20px;
}
.close-btn {
  position: relative;
  text-align: end;
  padding: 10px 0 0 8px;
}
.close-btn i {
  font-size: 16px;
  cursor: pointer;
  color: white;
}
.close-btn i:hover {
  color: #d5ab3d;
}
.searchbox {
  margin-top: 8px;
  border-radius: 5px;
  margin-bottom: 10px;
  display: grid;
}
.searchbox #searchForm {
  z-index: 1000;
  padding: 0px 35px 30px 35px;
}
.searchbox-enter-active {
  animation: searchbox-in 0.7s;
}
.searchbox-leave-active {
  animation: searchbox-out 0.5s;
}
@keyframes searchbox-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes searchbox-out {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 0;
  }
}
.btn_change {
  min-width: 100px;
  float: left;
}
.label {
  color: rgb(139, 139, 139);
}
.title {
  font-weight: bold;
  font-size: 15px;
}
.title-mobile {
  font-weight: bold;
  font-size: 13px;
}
.origin {
  padding: 0 40px 0 0;
}
.destination {
  padding: 0 40px 0 0;
}
.departure {
  padding: 0 20px 0 0;
}

.return {
  padding: 0 20px 0 0;
}

.pax {
  padding: 0 20px 0 0;
}
@media only screen and (max-width: 750px) {
 .search-summary {
  display: none !important;
}
.search-summary-mobile {
   display: block !important;
  
}
}

.search-summary {
  display: block;
  border-bottom: 1px solid #dfdfdf;
  min-height: 55px;
  position: relative;
  background: #fff;
    padding: 15px;
  border-radius: 20px;
}
.search-summary-item{
  padding-right: 30px;
}
.search-summary-mobile {
   display: none;
  border-bottom: 1px solid #dfdfdf;
  min-height: 55px;
  position: relative;
  background: #fff;
  padding: 15px;
  border-radius: 20px;
}
.border-left-mobile {
  padding: 0px 5px 0px 5px;
    border-left: 1px solid #dee2e6 !important;
        display: grid;
}
.icondirection {
  right: -18px;
  top: 2px;
}
.icondirection {
  padding: 2px 2px 2px 1px !important;
  background: #fff;
  border: 1px solid #dfdfdf !important;
  border-radius: 2.8em;
  height: 34px;
  position: absolute;
  bottom: 25%;
  width: 34px;
  padding-top: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 34px;
  vertical-align: middle;
}
</style>